import '../Body.css';
import React from "react";
import landingImage from "../../assets/images/landingImage.png";

import StudentSpotlight from "../../assets/components/StudentSpotlight.js"
import AboutBlurb from "../AboutBlurb.js"

function Home(props) {

    return (
        <div className="home">
            <img className="landingImage" src={landingImage} alt="three pop out web browsers with people popping out"></img>
            <AboutBlurb isMobile = {props.isMobile}></AboutBlurb>
            <p className="subPageHeader"> WHAT WE DO </p>
            <p className="subPageBodyText"> Future Tech Founders is a hands-on learning program designed for high school students with entrepreneurial ambitions. Our Accelerator Academy guides students through the process of building a fully functional web, mobile, or desktop application over six weeks of engaging lectures, interactive lab sessions, and guided assignments.</p>
            <p onClick={() => props.setActiveTab("about")} className="subPageButton"> learn more!</p>
            <StudentSpotlight isMobile = {props.isMobile}></StudentSpotlight>

        </div>
    )
}

export default Home;